import { api } from "./apiBaseQuery";

export const emailTemplateServices: any = api.injectEndpoints({
  endpoints: (builder) => ({
    getEmailTemplates: builder.mutation({
      query: () => {
        return {
          url: `Plantillas`,
          method: "GET",
        };
      },
    }),
    getTemplateTypes: builder.query({
      query: () => {
        return {
          url: `Plantillas/Tipos`,
        };
      },
    }),
    createEmailTemplate: builder.mutation({
      query: (body) => {
        return {
          url: "Plantillas",
          method: "POST",
          body,
        };
      },
    }),
    updateEmailTemplate: builder.mutation({
      query: (body) => {
        const id = body.id;
        delete body.id;
        return {
          url: `Plantillas/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
    changeEmailTemplateState: builder.mutation({
      query: (id) => {
        return {
          url: `Plantillas/${id}`,
          method: "DELETE",
        };
      },
    }),
    getTranslatableFields: builder.query({
      query: ({ table, id }: { table: string; id: number | string }) => {
        return {
          url: `Traducciones/GetTranslationsByKey?table=${table}&id=${id}`,
          method: "GET",
        };
      },
    }),
    createTranslation: builder.mutation({
      query: (body) => {
        return {
          url: "Traducciones/Create",
          method: "POST",
          body,
        };
      },
    }),
    updateTranslation: builder.mutation({
      query: (body) => {
        return {
          url: "Traducciones/Update",
          method: "PUT",
          body, // El body incluye traduccionId, tipo, locale y campoTraduccion
        };
      },
    }),
  }),
});

export const {
  useGetEmailTemplatesMutation,
  useGetTemplateTypesQuery,
  useCreateEmailTemplateMutation,
  useUpdateEmailTemplateMutation,
  useChangeEmailTemplateStateMutation,
  useGetTranslatableFieldsQuery,
  useCreateTranslationMutation,
  useUpdateTranslationMutation,
} = emailTemplateServices;
